import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';
import { useResponsive } from '@sg/garnish';

export const JoinSgRewardsBodyContainer = (props: PropsWithChildren) => {
  const { match } = useResponsive();

  return (
    <View style={match([styles.containerXS, styles.containerSM])}>
      {props.children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flex: 1,
    justifyContent: 'space-between',
    marginVertical: theme.spacing['4'],
    marginHorizontal: theme.spacing['6'],
  },
  containerSM: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: theme.spacing['4'],
    marginHorizontal: theme.spacing['6'],
    gap: theme.spacing['8'],
  },
});
